import React, { useState, Children } from 'react';
import { StoreIcon, DollarSignIcon, TruckIcon, TagIcon, HeartIcon, PercentIcon, PlusIcon, SearchIcon, ExternalLinkIcon, XIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
interface Nonprofit {
  id: string;
  name: string;
  category: string;
  location: string;
  website: string;
  status: 'approved' | 'pending';
}
const StoreSettings = () => {
  const [donationType, setDonationType] = useState<'flat' | 'per-type'>('flat');
  const [donationMethod, setDonationMethod] = useState<'percentage' | 'fixed'>('percentage');
  const [flatDonation, setFlatDonation] = useState('');
  const [bookDonation, setBookDonation] = useState('');
  const [merchDonation, setMerchDonation] = useState('');
  const [selectedNonprofits, setSelectedNonprofits] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [showDonationsPublicly, setShowDonationsPublicly] = useState(true);
  const [newNonprofit, setNewNonprofit] = useState({
    name: '',
    category: '',
    location: '',
    website: ''
  });
  const [showNoResultsForm, setShowNoResultsForm] = useState(false);
  const nonprofits: Nonprofit[] = [{
    id: '1',
    name: "Children's Literacy Foundation",
    category: 'Education',
    location: 'Vermont, USA',
    website: 'https://clifonline.org',
    status: 'approved'
  }, {
    id: '2',
    name: 'Book Access for All',
    category: 'Education',
    location: 'New York, USA',
    website: 'https://example.com',
    status: 'approved'
  }, {
    id: '3',
    name: 'Libraries First',
    category: 'Education',
    location: 'California, USA',
    website: 'https://example.com',
    status: 'approved'
  }, {
    id: '4',
    name: 'Rural Library Project',
    category: 'Education',
    location: 'Montana, USA',
    website: 'https://example.com',
    status: 'approved'
  }, {
    id: '5',
    name: 'Literacy for All',
    category: 'Education',
    location: 'Texas, USA',
    website: 'https://example.com',
    status: 'approved'
  }];
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-14556" data-mp="31zkd3vilihz1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14557" data-mp="31y97rr9i525t">
        <div className="text-center mb-8" data-id="element-14558" data-mp="2xyiar5tdtpsu">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-14559" data-mp="2xvcjpl170duh">Store Settings</h1>
          <p className="mt-2 text-lg text-gray-600" data-id="element-14560" data-mp="2a8e5yv4gjk09">
            Manage your store preferences
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2" data-id="element-14561" data-mp="256owvl0spget">
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-14562" data-mp="2j181m347ow0a">
            <div className="flex items-center mb-4" data-id="element-14563" data-mp="2e9hoxqhsxw5p">
              <StoreIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-14564" data-mp="2e7ws1u80m14o" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-14565" data-mp="1qjdmhmgco2ga">
                Store Details
              </h2>
            </div>
            <div className="space-y-4" data-id="element-14566" data-mp="1mhsb65jgrw87">
              <div data-id="element-14567" data-mp="1cedansu19nrx">
                <label className="block text-sm font-medium text-gray-700" data-id="element-14568" data-mp="1cdtp8256ch95">
                  Store Name
                </label>
                <input type="text" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500" data-id="element-14569" data-mp="1h5v9obchxea9" />
              </div>
              <div data-id="element-14570" data-mp="17fjx60eqxwrr">
                <label className="block text-sm font-medium text-gray-700" data-id="element-14571" data-mp="1v4uz3l7u1x7h">
                  Description
                </label>
                <textarea className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500" rows={3} data-id="element-14572" data-mp="2047jlzb8es6w" />
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-14573" data-mp="1q7urh5vc4me9">
            <div className="flex items-center mb-4" data-id="element-14574" data-mp="9qqj2lbzreuj">
              <HeartIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-14575" data-mp="eqlb4s7i6ah6" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-14576" data-mp="erwews0y7i8a">
                Donation Settings
              </h2>
            </div>
            <div className="space-y-6" data-id="element-14577" data-mp="q7atsa3b791p">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg" data-id="element-14578" data-mp="q6969653wu33">
                <div className="flex items-center" data-id="element-14579" data-mp="l8zg1o9w8ee7">
                  {showDonationsPublicly ? <EyeIcon className="h-5 w-5 text-purple-600 mr-3" data-id="element-14580" data-mp="g9wg2i8rsyd3" /> : <EyeOffIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-14581" data-mp="1dvkaixlo16lz" />}
                  <div data-id="element-14582" data-mp="18x8weaoc89xy">
                    <p className="font-medium text-gray-900" data-id="element-14583" data-mp="18y1wwtwpe37n">
                      Show on Profile & Products
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-14584" data-mp="yzcr3zi3097r">
                      Display donation info publicly
                    </p>
                  </div>
                </div>
                <button onClick={() => setShowDonationsPublicly(!showDonationsPublicly)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${showDonationsPublicly ? 'bg-purple-600' : 'bg-gray-300'}`} data-id="element-14585" data-mp="3omk375nfwlsm">
                  <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${showDonationsPublicly ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-14586" data-mp="295yzd4w79vkt" />
                </button>
              </div>
              <div data-id="element-14587" data-mp="2iuz2n0hqjd4t">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14588" data-mp="2ixux2eudjjoi">
                  Donation Type
                </label>
                <div className="grid grid-cols-2 gap-3" data-id="element-14589" data-mp="2rvop3dl3vr5v">
                  <button onClick={() => setDonationType('flat')} className={`px-4 py-2 text-sm font-medium rounded-md ${donationType === 'flat' ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-14590" data-mp="2ru4003hk90fe">
                    Flat Rate
                  </button>
                  <button onClick={() => setDonationType('per-type')} className={`px-4 py-2 text-sm font-medium rounded-md ${donationType === 'per-type' ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-14591" data-mp="uhccjwr6xe5t">
                    Per Product Type
                  </button>
                </div>
              </div>
              <div data-id="element-14592" data-mp="1ddc270wp45m8">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14593" data-mp="19dtj8aofq4m1">
                  Donation Method
                </label>
                <div className="grid grid-cols-2 gap-3" data-id="element-14594" data-mp="1n46rke58nlbw">
                  <button onClick={() => setDonationMethod('percentage')} className={`px-4 py-2 text-sm font-medium rounded-md ${donationMethod === 'percentage' ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-14595" data-mp="1i656jno95bxs">
                    Percentage
                  </button>
                  <button onClick={() => setDonationMethod('fixed')} className={`px-4 py-2 text-sm font-medium rounded-md ${donationMethod === 'fixed' ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-14596" data-mp="2boa6qddlaj9j">
                    Fixed Amount
                  </button>
                </div>
              </div>
              {donationType === 'flat' ? <div data-id="element-14597" data-mp="1wtnecux42mof">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14598" data-mp="1wuyjay2am0h4">
                    Donation Amount{' '}
                    {donationMethod === 'percentage' ? '(%)' : '($)'}
                  </label>
                  <div className="mt-1 relative rounded-md shadow-sm" data-id="element-14599" data-mp="1939kqzyvofrq">
                    {donationMethod === 'fixed' && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-14600" data-mp="1e2m77jlu7kts">
                        <span className="text-gray-500 sm:text-sm" data-id="element-14601" data-mp="1tjcflia70h0o">$</span>
                      </div>}
                    <input type="number" value={flatDonation} onChange={e => setFlatDonation(e.target.value)} className={`block w-full rounded-md border-gray-300 focus:border-purple-500 focus:ring-purple-500 ${donationMethod === 'fixed' ? 'pl-7' : ''}`} placeholder={donationMethod === 'percentage' ? '5' : '1.00'} data-id="element-14602" data-mp="1pjacr5sq1hjt" />
                    {donationMethod === 'percentage' && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-14603" data-mp="wumxprykfoep">
                        <PercentIcon className="h-4 w-4 text-gray-400" data-id="element-14604" data-mp="rva1whppv6zz" />
                      </div>}
                  </div>
                </div> : <div className="space-y-4" data-id="element-14605" data-mp="csibtci15ddf">
                  <div data-id="element-14606" data-mp="crh3vgwb96zx">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14607" data-mp="cucwqqtax5hi">
                      Book Sales Donation{' '}
                      {donationMethod === 'percentage' ? '(%)' : '($)'}
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-14608" data-mp="rpsub5t3bjin">
                      {donationMethod === 'fixed' && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-14609" data-mp="3q8gbjp4nlxoe">
                          <span className="text-gray-500 sm:text-sm" data-id="element-14610" data-mp="3v69hch21opo5">$</span>
                        </div>}
                      <input type="number" value={bookDonation} onChange={e => setBookDonation(e.target.value)} className={`block w-full rounded-md border-gray-300 focus:border-purple-500 focus:ring-purple-500 ${donationMethod === 'fixed' ? 'pl-7' : ''}`} placeholder={donationMethod === 'percentage' ? '5' : '1.00'} data-id="element-14611" data-mp="8qexmg3z7uog" />
                      {donationMethod === 'percentage' && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-14612" data-mp="16s90a9bo836t">
                          <PercentIcon className="h-4 w-4 text-gray-400" data-id="element-14613" data-mp="1atm5qiauq4d7" />
                        </div>}
                    </div>
                  </div>
                  <div data-id="element-14614" data-mp="j50vdsi5mw5b">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14615" data-mp="j2em9ofm88kz">
                      Merchandise Sales Donation{' '}
                      {donationMethod === 'percentage' ? '(%)' : '($)'}
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-14616" data-mp="3rldtto24yw0e">
                      {donationMethod === 'fixed' && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-14617" data-mp="3vkmkgk1vqdrq">
                          <span className="text-gray-500 sm:text-sm" data-id="element-14618" data-mp="3o0kf8kvyd9zb">$</span>
                        </div>}
                      <input type="number" value={merchDonation} onChange={e => setMerchDonation(e.target.value)} className={`block w-full rounded-md border-gray-300 focus:border-purple-500 focus:ring-purple-500 ${donationMethod === 'fixed' ? 'pl-7' : ''}`} placeholder={donationMethod === 'percentage' ? '5' : '1.00'} data-id="element-14619" data-mp="3f1qag78gxdao" />
                      {donationMethod === 'percentage' && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-14620" data-mp="2rakvduacqp1f">
                          <PercentIcon className="h-4 w-4 text-gray-400" data-id="element-14621" data-mp="2he81owet4b6o" />
                        </div>}
                    </div>
                  </div>
                </div>}
              <div data-id="element-14622" data-mp="2cpfcjk5o4oxc">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14623" data-mp="2cqqj1rqi0as5">
                  Supported Nonprofits
                </label>
                <div className="space-y-2 mb-4" data-id="element-14624" data-mp="1xuj1z0adzph3">
                  {/* Selected Nonprofits */}
                  <div className="space-y-2 mb-4" data-id="element-14625" data-mp="22tluxmd3e58p">
                    {selectedNonprofits.map(id => {
                    const nonprofit = nonprofits.find(np => np.id === id);
                    const donationSplit = donationType === 'flat' ? Number(flatDonation) / (selectedNonprofits.length || 1) : null;
                    if (!nonprofit) return null;
                    return <div key={nonprofit.id} className="flex items-center justify-between p-2 bg-purple-50 rounded-md" data-id="element-14626" data-mp="39dv9i1b3y0kh">
                          <div className="flex items-center space-x-2" data-id="element-14627" data-mp="12pcp4jec7feh">
                            <span className="text-sm font-medium text-gray-900" data-id="element-14628" data-mp="xs321aef7ftt">
                              {nonprofit.name}
                              {donationSplit && <span className="ml-2 text-xs text-purple-600" data-id="element-14629" data-mp="17jgy1875xxi7">
                                  (${donationSplit.toFixed(2)} per sale)
                                </span>}
                            </span>
                          </div>
                          <button onClick={() => setSelectedNonprofits(selectedNonprofits.filter(npId => npId !== nonprofit.id))} className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-14630" data-mp="strr0wce2za0">
                            <XIcon className="h-4 w-4" data-id="element-14631" data-mp="2zild9243u3ky" />
                          </button>
                        </div>;
                  })}
                  </div>
                  {/* Search Input */}
                  <div className="relative" data-id="element-14632" data-mp="39hav4uw03o17">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-14633" data-mp="39ey6xzznghfp">
                      <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-14634" data-mp="3eeb2d94l6wtw" />
                    </div>
                    <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-purple-500 focus:border-purple-500 sm:text-sm" placeholder="Search nonprofits..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-14635" data-mp="3ifmmx08lsrv8" />
                  </div>
                  {/* Search Results */}
                  {searchTerm && <div className="mt-2 max-h-60 overflow-auto border border-gray-200 rounded-md" data-id="element-14636" data-mp="1llmj3o2clwqg">
                      {nonprofits.filter(np => np.name.toLowerCase().includes(searchTerm.toLowerCase()) && !selectedNonprofits.includes(np.id)).map(nonprofit => <div key={nonprofit.id} onClick={() => setSelectedNonprofits([...selectedNonprofits, nonprofit.id])} className="flex items-center space-x-3 p-3 hover:bg-gray-50 border-b border-gray-200 cursor-pointer" data-id="element-14637" data-mp="1zgyhc5fpq5c4">
                            <div className="flex-1" data-id="element-14638" data-mp="qc95bl8txu9c">
                              <div className="flex items-center justify-between" data-id="element-14639" data-mp="bk8rimdntdfy">
                                <span className="text-sm font-medium text-gray-700" data-id="element-14640" data-mp="gjtnqp1g37oz">
                                  {nonprofit.name}
                                </span>
                                <a href={nonprofit.website} target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700" onClick={e => e.stopPropagation()} data-id="element-14641" data-mp="6m77nz8eta3f">
                                  <ExternalLinkIcon className="h-4 w-4" data-id="element-14642" data-mp="1mymcnjh13esa" />
                                </a>
                              </div>
                              <div className="mt-1 flex items-center space-x-2" data-id="element-14643" data-mp="3cim78stnrkil">
                                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-700" data-id="element-14644" data-mp="37izs2du9ru75">
                                  {nonprofit.category}
                                </span>
                                <span className="text-xs text-gray-500" data-id="element-14645" data-mp="3hf2w5p8om2wq">
                                  {nonprofit.location}
                                </span>
                              </div>
                            </div>
                          </div>)}
                      {/* No results found message */}
                      {searchTerm && nonprofits.filter(np => np.name.toLowerCase().includes(searchTerm.toLowerCase()) && !selectedNonprofits.includes(np.id)).length === 0 && <div className="p-4 text-center" data-id="element-14646" data-mp="1jxucsmo88apr">
                            <p className="text-gray-500 mb-3" data-id="element-14647" data-mp="1oxqkox01omal">
                              No nonprofits found matching "{searchTerm}"
                            </p>
                            {!showNoResultsForm ? <button onClick={() => {
                      setShowNoResultsForm(true);
                      setNewNonprofit({
                        ...newNonprofit,
                        name: searchTerm
                      });
                    }} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500" data-id="element-14648" data-mp="1yo1n2f42ynfd">
                                <PlusIcon className="-ml-0.5 mr-2 h-4 w-4" data-id="element-14649" data-mp="erdtgpoztwr3" />
                                Add "{searchTerm}" as new nonprofit
                              </button> : <div className="mt-4 p-4 bg-gray-50 rounded-md" data-id="element-14650" data-mp="5yiwskdld9cx">
                                <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-14651" data-mp="10hew2rwjg31">
                                  Submit "{searchTerm}" for Approval
                                </h4>
                                <div className="space-y-4" data-id="element-14652" data-mp="3n7fpl46u0rn1">
                                  <div data-id="element-14653" data-mp="3j6lyk1y3ewpx">
                                    <label className="block text-sm font-medium text-gray-700" data-id="element-14654" data-mp="3j7oni4buup37">
                                      Organization Name
                                    </label>
                                    <input type="text" value={newNonprofit.name} onChange={e => setNewNonprofit({
                            ...newNonprofit,
                            name: e.target.value
                          })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 sm:text-sm" data-id="element-14655" data-mp="1he7iz9j0u4co" />
                                  </div>
                                  <div data-id="element-14656" data-mp="1hzuzgquj5b6a">
                                    <label className="block text-sm font-medium text-gray-700" data-id="element-14657" data-mp="1d2bgxeqsuc8j">
                                      Category
                                    </label>
                                    <select value={newNonprofit.category} onChange={e => setNewNonprofit({
                            ...newNonprofit,
                            category: e.target.value
                          })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 sm:text-sm" data-id="element-14658" data-mp="185l5x5tuq6tz">
                                      <option value="" data-id="element-14659" data-mp="2r2pu26pcoc9q">
                                        Select a category
                                      </option>
                                      <option value="Education" data-id="element-14660" data-mp="2w2uaxxu6790h">
                                        Education
                                      </option>
                                      <option value="Hunger" data-id="element-14661" data-mp="35zyrni58yc9w">Hunger</option>
                                      <option value="Domestic Violence" data-id="element-14662" data-mp="gao9kiicbvyo">
                                        Domestic Violence
                                      </option>
                                      <option value="Healthcare" data-id="element-14663" data-mp="2hbulmniiyjma">
                                        Healthcare
                                      </option>
                                      <option value="Environment" data-id="element-14664" data-mp="2ccrmfjp877m8">
                                        Environment
                                      </option>
                                      <option value="Arts" data-id="element-14665" data-mp="2mc8uu8vv3zlw">
                                        Arts & Culture
                                      </option>
                                    </select>
                                  </div>
                                  <div data-id="element-14666" data-mp="1tkp483wxrj9v">
                                    <label className="block text-sm font-medium text-gray-700" data-id="element-14667" data-mp="27e6mzmhssryu">
                                      Location
                                    </label>
                                    <input type="text" value={newNonprofit.location} onChange={e => setNewNonprofit({
                            ...newNonprofit,
                            location: e.target.value
                          })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 sm:text-sm" placeholder="City, State, Country" data-id="element-14668" data-mp="1ex42adbsrq3j" />
                                  </div>
                                  <div data-id="element-14669" data-mp="19knrfqt8vs36">
                                    <label className="block text-sm font-medium text-gray-700" data-id="element-14670" data-mp="19jvyknr188gl">
                                      Website
                                    </label>
                                    <input type="url" value={newNonprofit.website} onChange={e => setNewNonprofit({
                            ...newNonprofit,
                            website: e.target.value
                          })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 sm:text-sm" placeholder="https://" data-id="element-14671" data-mp="3u9lez57dw2be" />
                                  </div>
                                  <div className="flex justify-end space-x-3" data-id="element-14672" data-mp="sbd5zc2djhlw">
                                    <button type="button" onClick={() => {
                            setShowNoResultsForm(false);
                            setSearchTerm('');
                          }} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500" data-id="element-14673" data-mp="ndbnas8v1kay">
                                      Cancel
                                    </button>
                                    <button type="button" onClick={() => {
                            // Handle submission logic here
                            setShowNoResultsForm(false);
                            setSearchTerm('');
                            setNewNonprofit({
                              name: '',
                              category: '',
                              location: '',
                              website: ''
                            });
                          }} className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500" data-id="element-14674" data-mp="27a0lfoyt04i4">
                                      Submit for Approval
                                    </button>
                                  </div>
                                </div>
                              </div>}
                          </div>}
                    </div>}
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-14675" data-mp="1lhed1mfxtmv4">
            <div className="flex items-center mb-4" data-id="element-14676" data-mp="1giuu7uwn4r6z">
              <DollarSignIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-14677" data-mp="1gg8j5lajjtk0" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-14678" data-mp="204d3be326b89">
                Payment Settings
              </h2>
            </div>
            <div className="space-y-4" data-id="element-14679" data-mp="1q5nusbx1y34o">
              <div data-id="element-14680" data-mp="1q4madgu5c4aa">
                <label className="block text-sm font-medium text-gray-700" data-id="element-14681" data-mp="1q55u933cx2qy">
                  Currency
                </label>
                <select className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500" data-id="element-14682" data-mp="1v6ldqqpvz178">
                  <option data-id="element-14683" data-mp="1l6ueycuam01c">USD</option>
                  <option data-id="element-14684" data-mp="1l7vv2vq61cpx">EUR</option>
                  <option data-id="element-14685" data-mp="17ffzgfzlggz1">GBP</option>
                </select>
              </div>
              <div data-id="element-14686" data-mp="17dcyj0wwl3fj">
                <label className="block text-sm font-medium text-gray-700" data-id="element-14687" data-mp="1ce0w65fn0iiq">
                  Payment Methods
                </label>
                <div className="mt-2 space-y-2" data-id="element-14688" data-mp="xib9e52mo1cy">
                  <label className="flex items-center" data-id="element-14689" data-mp="12g3anpp5wztt">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-14690" data-mp="12fl7sa7zvncx" />
                    <span className="ml-2" data-id="element-14691" data-mp="1dw9c5t357e1d">Credit Card</span>
                  </label>
                  <label className="flex items-center" data-id="element-14692" data-mp="18x66q7j935sv">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-14693" data-mp="18vlckj0ulovj" />
                    <span className="ml-2" data-id="element-14694" data-mp="z0a5mmvollyc">PayPal</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-14695" data-mp="u6p44kuvq9ue">
            <div className="flex items-center mb-4" data-id="element-14696" data-mp="q7gbxkfhmk0y">
              <TruckIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-14697" data-mp="l83rf6c39p1j" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-14698" data-mp="l5r0w4s9m6cv">Shipping</h2>
            </div>
            <div className="space-y-4" data-id="element-14699" data-mp="gav5qvrqf2vj">
              <div data-id="element-14700" data-mp="b95upg4iep7g">
                <label className="block text-sm font-medium text-gray-700" data-id="element-14701" data-mp="bapaz6q61098">
                  Shipping Methods
                </label>
                <div className="mt-2 space-y-2" data-id="element-14702" data-mp="17tr87enfa5e">
                  <label className="flex items-center" data-id="element-14703" data-mp="640zw7yfizr1">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-14704" data-mp="66n5w35o9775" />
                    <span className="ml-2" data-id="element-14705" data-mp="g1orip0qnr4z">Standard Shipping</span>
                  </label>
                  <label className="flex items-center" data-id="element-14706" data-mp="3elygetnjgq33">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-14707" data-mp="3jjgsuu0rlnfu" />
                    <span className="ml-2" data-id="element-14708" data-mp="3ohi813v2l2m1">Express Shipping</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-14709" data-mp="2vt2yuxymdeim">
            <div className="flex items-center mb-4" data-id="element-14710" data-mp="30t8tmn06rh4x">
              <TagIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-14711" data-mp="30rnz2xdvfy72" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-14712" data-mp="2929w3v048l1c">Inventory</h2>
            </div>
            <div className="space-y-4" data-id="element-14713" data-mp="2e2furv4sz7sx">
              <div data-id="element-14714" data-mp="2e1ead01wd8yj">
                <label className="block text-sm font-medium text-gray-700" data-id="element-14715" data-mp="2dzjx87wval50">
                  Stock Management
                </label>
                <div className="mt-2 space-y-2" data-id="element-14716" data-mp="24372r7ti0397">
                  <label className="flex items-center" data-id="element-14717" data-mp="241vryo1mxv8l">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-14718" data-mp="1qc1yttj3kot2" />
                    <span className="ml-2" data-id="element-14719" data-mp="1ge5srg50ok1t">Track Inventory</span>
                  </label>
                  <label className="flex items-center" data-id="element-14720" data-mp="1gcb6nyi0elw5">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-14721" data-mp="1le0hpe58ezk8" />
                    <span className="ml-2" data-id="element-14722" data-mp="1bfkq7a2aloa7">Low Stock Alerts</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-14723" data-mp="ssllvyvziqqj">
          <button className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700" data-id="element-14724" data-mp="nspio1v433c1">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
};
export default StoreSettings;